import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { JobInformation } from '@planone/bau365/util-user-data';

import { downloadBusinessCard, loadBusinessCard, openPage } from './business-card.actions';
import { getBusinessCard, isBusinessCardLoaded } from './business-card.selectors';

@Injectable()
export class BusinessCardFacade {
  businessCard$ = this.store.pipe(select(getBusinessCard));
  loaded$ = this.store.pipe(select(isBusinessCardLoaded));

  openPage() {
    this.store.dispatch(openPage());
  }

  loadBusinessCard(id: string) {
    this.store.dispatch(loadBusinessCard({ id }));
  }

  downloadBusinessCard(businessCard: JobInformation) {
    this.store.dispatch(downloadBusinessCard({ businessCard }));
  }

  constructor(private readonly store: Store) {}
}
